import { copyJsonObject } from "../commonUtils";
import { FREEDAY_BID_TYPE } from "./bidConstants";

export const processBidAwardPayload = (payload, bidLines, bidGroup) => {
  let updatedBidLines = copyJsonObject(bidLines);
  let updatedBidGroup = copyJsonObject(bidGroup);
  let bidLineIdx;
  for (const eid of Object.keys(payload.bid_award_map)) {
    const awardResult = payload.bid_award_map[eid];
    const bidGroupIdx = updatedBidGroup.findIndex((emp) => emp.eid === eid);
    updatedBidGroup = assignBidGroup(updatedBidGroup, bidGroupIdx, awardResult.bidLine, awardResult.awardType);
    updatedBidGroup[bidGroupIdx].isManualIAOEntryRequired = false;

    switch (awardResult.awardType) {
      case "AA":
      case "PB":
      case "BL":
        bidLineIdx = updatedBidLines.findIndex((bidLine) => bidLine?.lineNumber === awardResult.bidLine);
        updatedBidLines = assignBidLine(updatedBidLines, bidLineIdx, awardResult);
        break;
      case "NB":
      case "NEC":
      case "IAO":
        break;
      default:
        console.error("Unrecognized awardType");
        break;
    }
  }
  return {
    bidLines: updatedBidLines,
    bidGroup: updatedBidGroup,
    awardLog: payload.award_log_file_name_list,
  };
};

const updateFreedayBidAllotmentState = (state, awardedDays, employeeData) => {
  const awardedFreeday = awardedDays.length > 0 ? awardedDays[0].date : undefined;
  const allotmentIdx = state.findIndex((allotment) => allotment?.date === awardedFreeday);

  if (allotmentIdx >= 0) {
    if (!state[allotmentIdx].awardedEmps) {
      state[allotmentIdx].awardedEmps = [];
    }
    state[allotmentIdx].awardedEmps.push(employeeData);
  }

  return state;
};

const createFreedayBidEmployeeData = (awardResult, bidGroup) => ({
  eid: awardResult.eid,
  firstName: awardResult.shortName,
  lastName: awardResult.lastName,
  awardType: awardResult.awardType,
  awardedAllotment: awardResult.awardedAllotment,
  awardedDays: awardResult.awardedDays,
  awardedRank: awardResult.rank,
  awardedTimeOffType: awardResult.awardedTimeOffType,
  standardRelief: bidGroup.standardRelief,
  homeStation: bidGroup.homeStation,
  isTemp: bidGroup.isTemp,
});

export const processFreedayBidAwardPayload = (payload, standardDayState, reliefDayState, bidGroup) => {
  let updatedStandardDayState = copyJsonObject(standardDayState);
  let updatedReliefDayState = copyJsonObject(reliefDayState);
  let updatedBidGroup = copyJsonObject(bidGroup);
  let employeeData;
  for (const eid of Object.keys(payload.bid_award_map)) {
    const awardResult = payload.bid_award_map[eid];
    const bidGroupIdx = updatedBidGroup.findIndex((emp) => emp.eid === eid);
    updatedBidGroup[bidGroupIdx].awardType = awardResult.awardType;
    updatedBidGroup[bidGroupIdx].awardedDays = awardResult.awardedDays;
    updatedBidGroup[bidGroupIdx].awardedAllotment = awardResult.awardedAllotment;
    updatedBidGroup[bidGroupIdx].awardBsAmPm = awardResult.awardBsAmPm;
    updatedBidGroup[bidGroupIdx].awardedTimeOffType = awardResult.awardedTimeOffType;

    switch (awardResult.awardType) {
      case "AA":
      case "NB":
      case "NEC":
        employeeData = createFreedayBidEmployeeData(awardResult, updatedBidGroup[bidGroupIdx]);
        if (employeeData.standardRelief === FREEDAY_BID_TYPE.STANDARD) {
          updatedStandardDayState = updateFreedayBidAllotmentState(
            standardDayState,
            awardResult.awardedDays,
            employeeData
          );
        } else {
          updatedReliefDayState = updateFreedayBidAllotmentState(reliefDayState, awardResult.awardedDays, employeeData);
        }
        break;
      case "NS":
        break;
      default:
        console.error("Unrecognized awardType");
        break;
    }
  }

  return {
    standardDayState: updatedStandardDayState,
    reliefDayState: updatedReliefDayState,
    bidGroup: updatedBidGroup,
    awardLog: payload.award_log_file_name_list,
  };
};

const updateMTOBidAllotmentState = (state, awardedDays, employeeData) => {
  for (let awardedDate of awardedDays) {
    const allotmentIdx = state.findIndex((allotment) => allotment?.date === awardedDate.date);
    if (allotmentIdx >= 0) {
      if (!state[allotmentIdx].awardedEmps) {
        state[allotmentIdx].awardedEmps = [];
      }
      state[allotmentIdx].awardedEmps.push(employeeData);
    }
  }

  return state;
};

const createMTOBidEmployeeData = (awardResult, bidGroup) => ({
  eid: awardResult.eid,
  firstName: awardResult.shortName,
  lastName: awardResult.lastName,
  awardType: awardResult.awardType,
  awardedDays: awardResult.awardedDays,
  awardedRank: awardResult.rank,
  awardedTimeOffType: awardResult.awardedTimeOffType,
  homeStation: bidGroup.homeStation,
  isTemp: bidGroup.isTemp,
});

export const processMTOBidAwardPayload = (payload, allotmentDayState, bidGroup) => {
  let updatedAllotmentDayState = copyJsonObject(allotmentDayState);
  let updatedBidGroup = copyJsonObject(bidGroup);
  let employeeData;
  for (const eid of Object.keys(payload.bid_award_map)) {
    const awardResult = payload.bid_award_map[eid];
    const bidGroupIdx = updatedBidGroup.findIndex((emp) => emp.eid === eid);
    updatedBidGroup[bidGroupIdx].awardType = awardResult.awardType;
    updatedBidGroup[bidGroupIdx].awardedDays = awardResult.awardedDays;
    updatedBidGroup[bidGroupIdx].awardBsAmPm = awardResult.awardBsAmPm;
    updatedBidGroup[bidGroupIdx].awardedTimeOffType = awardResult.awardedTimeOffType;

    switch (awardResult.awardType) {
      case "AA":
      case "PA":
        employeeData = createMTOBidEmployeeData(awardResult, updatedBidGroup[bidGroupIdx]);
        updatedAllotmentDayState = updateMTOBidAllotmentState(allotmentDayState, awardResult.awardedDays, employeeData);
        break;
      case "NB":
      case "NEC":
      case "NS":
      case "ZB":
        break;
      default:
        console.error("Unrecognized awardType");
        break;
    }
  }

  return {
    allotmentDayState: updatedAllotmentDayState,
    bidGroup: updatedBidGroup,
    awardLog: payload.award_log_file_name_list,
  };
};

export const isBidLineUnawarded = (bidLines, bidLineNumber) => {
  const bidLineIdx = bidLines.findIndex((bidLine) => bidLine?.lineNumber === bidLineNumber);
  if (bidLineIdx !== -1) {
    return bidLines[bidLineIdx].awardedEid == null || bidLines[bidLineIdx].awardedEid === "";
  }
  return false;
};

export const isEmpAwardedALineContainingDupeLines = (bidLines, lineNumber) => {
  let count = 0;
  for (const line of bidLines) {
    if (line.isDupedLine && getMainLineNumber(line.lineNumber) === getMainLineNumber(lineNumber)) {
      count += 1;
    }
  }
  return count > 0;
};

export const adjustLineNumbers = (bidLines, bidGroup, removedLineNumber) => {
  const result = [];
  let updatedBidGroup = copyJsonObject(bidGroup);
  const processedBidLineNumbers = new Set();

  // Sort bidLines by lineNumber in descending order
  bidLines.sort((a, b) => b.lineNumber - a.lineNumber);

  bidLines.forEach((line) => {
    const [major, minor] = String(line.lineNumber).split(".").map(Number);

    if (line.lineNumber === removedLineNumber) {
      // Set lineNumber to undefined for the removed line in bidGroup
      const bidGroupIdx = bidGroup.findIndex((g) => g.awardedLine === removedLineNumber);
      if (bidGroupIdx !== -1) {
        updatedBidGroup = unAssignBidGroup(updatedBidGroup, bidGroupIdx);
      }
      return; // Skip this line as it's being removed
    }

    if (major === removedLineNumber) {
      // Bump down minor versions
      const newLineNumber = minor === 1 ? major : parseFloat(`${major}.${minor - 1}`);
      if (!processedBidLineNumbers.has(newLineNumber)) {
        result.push({
          ...line,
          lineNumber: newLineNumber,
          id: newLineNumber,
          isDupedLine: minor !== 1, // Mark the one changing from x.x to x as non dupe line
        });
        processedBidLineNumbers.add(newLineNumber);

        // Update bidGroup
        const bidGroupIdx = bidGroup.findIndex((g) => g.awardedLine === line.lineNumber);
        if (bidGroupIdx !== -1) {
          updatedBidGroup = assignBidGroup(
            updatedBidGroup,
            bidGroupIdx,
            newLineNumber,
            updatedBidGroup[bidGroupIdx].awardType,
            updatedBidGroup[bidGroupIdx].isNoBidOverridden
          );
          if (minor === 1) updatedBidGroup[bidGroupIdx].isNoBidOverridden = false; // Mark the one changing from x.x to x as non overriden line
        }
      }
    } else if (!processedBidLineNumbers.has(line.lineNumber)) {
      // Keep other bidLines unchanged
      result.push({
        ...line,
      });
      processedBidLineNumbers.add(line.lineNumber);
    }
  });

  // Sort the result array by lineNumber
  result.sort((a, b) => a.lineNumber - b.lineNumber);

  return { bidLines: result, bidGroup: updatedBidGroup };
};

export const processBidIAOAwardPayload = (payload, bidLines, bidGroup, ineligibleAtOpenList) => {
  let updatedBidLines = copyJsonObject(bidLines);
  let updatedBidGroup = copyJsonObject(bidGroup);
  for (const ineligibleEmp of ineligibleAtOpenList) {
    const awardResult = payload.bid_award_map[ineligibleEmp.eid];
    const bidGroupIdx = updatedBidGroup.findIndex((emp) => emp.eid === ineligibleEmp.eid);
    // change IAO to IAO-PB/AA/NB/NEC when IAO run returns new award type
    ineligibleEmp.awardType = awardResult.awardType;

    switch (awardResult.awardType) {
      case "AA":
      case "PB":
      case "BL":
      case "IAO-AA":
      case "IAO-PB":
        //Changing logic here to fix any lines got awarded for IAO without requiring to create dupelines
        if (isBidLineUnawarded(bidLines, awardResult.bidLine)) {
          const bidLineIdx = updatedBidLines.findIndex((bidLine) => bidLine?.lineNumber === awardResult.bidLine);
          if (bidLineIdx !== -1) {
            updatedBidLines = assignBidLine(updatedBidLines, bidLineIdx, ineligibleEmp);
            updatedBidLines[bidLineIdx].permanentBidPreferenceUsed = ineligibleEmp.permanentBidPreferenceUsed;
          }
          // Assign to bidGroup
          updatedBidGroup = assignBidGroup(updatedBidGroup, bidGroupIdx, awardResult.bidLine, ineligibleEmp.awardType);
        } else {
          const bidLineIdx = updatedBidLines.findIndex((bidLine) => bidLine?.lineNumber === awardResult.bidLine);
          let heldBidLine = updatedBidLines[bidLineIdx];
          let dupedLineObj = createDupedLine(updatedBidLines, heldBidLine);
          updatedBidLines = assignDupedBidLine(updatedBidLines, bidLineIdx, dupedLineObj, ineligibleEmp);

          // Assign to bidGroup
          updatedBidGroup = assignBidGroup(
            updatedBidGroup,
            bidGroupIdx,
            dupedLineObj.dupedLine.lineNumber,
            ineligibleEmp.awardType
          );
        }
        break;
      case "NB":
      case "NEC":
      case "IAO":
      case "IAO-NB":
      case "IAO-NEC":
        updatedBidGroup = unAssignBidGroup(updatedBidGroup, bidGroupIdx);
        updatedBidGroup[bidGroupIdx].isManualIAOEntryRequired = true;
        updatedBidGroup[bidGroupIdx].awardType = awardResult.awardType;
        break;
      default:
        console.error("Unrecognized awardType");
        break;
    }
  }
  return {
    bidLines: updatedBidLines,
    bidGroup: updatedBidGroup,
    awardLog: payload.award_log_file_name_list,
  };
};

export const createDupedLine = (bidLines, line, isNoBid = false) => {
  let dupedLine = copyJsonObject(line);
  const dupeCount = getNextDupedLineCount(bidLines, line.lineNumber);
  dupedLine.lineNumber = parseFloat(`${getMainLineNumber(line.lineNumber)}.${dupeCount}`);
  dupedLine.id = dupedLine.lineNumber;
  dupedLine.isDupedLine = true;
  for (const shift of dupedLine.shifts) {
    if (!shift.isOff) {
      shift["assignment"] = isNoBid ? shift["assignment"] : "Float";
      shift["position"] = isNoBid ? shift["position"] : "Float";
    }
  }
  dupedLine.assignedEmployee = null; //Should not copy assigned Employee information to dupline
  return { dupedLine: dupedLine, dupeCount: dupeCount };
};

export const getNextDupedLineCount = (bidLines, lineNumber) => {
  let count = 0;
  for (const line of bidLines) {
    if (line.isDupedLine && getMainLineNumber(line.lineNumber) === getMainLineNumber(lineNumber)) {
      count += 1;
    }
  }
  return count + 1;
};

export const cleanUpDupedLines = (bidLines, bidGroup) => {
  let cleanedUpBidLines = copyJsonObject(bidLines);
  let cleanedUpBidGroup = copyJsonObject(bidGroup);
  let dupeCountMap = {};
  let idx = 0;
  for (const line of cleanedUpBidLines) {
    if (line.isDupedLine) {
      let cleanedUpLine = copyJsonObject(line);
      const lineNumber = getMainLineNumber(line.lineNumber);
      if (lineNumber in dupeCountMap) {
        dupeCountMap[lineNumber] += 1;
      } else {
        dupeCountMap[lineNumber] = 1;
      }
      const newLineNumber = parseFloat(`${lineNumber}.${dupeCountMap[lineNumber]}`);
      cleanedUpLine.lineNumber = newLineNumber;
      cleanedUpLine.id = newLineNumber;
      cleanedUpBidLines[idx] = cleanedUpLine;

      const bidGroupIdx = cleanedUpBidGroup.findIndex((emp) => emp?.eid === cleanedUpLine.awardedEid);
      cleanedUpBidGroup[bidGroupIdx].awardedLine = cleanedUpLine.lineNumber;
    }
    idx += 1;
  }
  return {
    bidLines: cleanedUpBidLines,
    bidGroup: cleanedUpBidGroup,
  };
};

export const getMainLineNumber = (lineNumber) => {
  const mainLineNumber = lineNumber.toString().split(".")[0];
  return parseInt(mainLineNumber);
};

export const clearAwardData = (bidLines, bidGroup) => {
  // Clear Bid Lines
  let clearedBidLines = [];
  for (const bidLine of bidLines) {
    let clearedBidLine = copyJsonObject(bidLine);
    if (!clearedBidLine.isDupedLine) {
      clearedBidLine.awardType = undefined;
      clearedBidLine.awardedEid = undefined;
      clearedBidLine.awardedRank = undefined;
      clearedBidLine.awardedShortName = undefined;
      clearedBidLine.awardedLastName = undefined;
      clearedBidLine.permanentBidPreferenceUsed = undefined;
      clearedBidLines.push(clearedBidLine);
    }
  }

  // Clear Bid Group
  let clearedBidGroup = copyJsonObject(bidGroup);
  for (const bidGroup of clearedBidGroup) {
    bidGroup.awardedLine = undefined;
    bidGroup.awardType = undefined;
    bidGroup.isExpanded = false;
  }

  return {
    bidLines: clearedBidLines,
    bidGroup: clearedBidGroup,
  };
};

export const clearFreedayAwardData = (standardDayState, reliefDayState, bidGroup) => {
  const clearAwardedEmps = (state) => ({
    ...state,
    awardedEmps: [],
  });

  // Clear Bid Group
  let clearedBidGroup = copyJsonObject(bidGroup);
  for (const bidGroup of clearedBidGroup) {
    bidGroup.awardedAllotment = undefined;
    bidGroup.awardedDays = undefined;
    bidGroup.awardType = undefined;
    bidGroup.awardedTimeOffType = undefined;
    bidGroup.awardBsAmPm = undefined;
  }

  return {
    standardDayState: standardDayState.map(clearAwardedEmps),
    reliefDayState: reliefDayState.map(clearAwardedEmps),
    bidGroup: clearedBidGroup,
  };
};

export const clearMTOBidAwardData = (allotmentDayState, bidGroup) => {
  const clearAwardedEmps = (state) => ({
    ...state,
    awardedEmps: [],
  });

  // Clear Bid Group
  let clearedBidGroup = copyJsonObject(bidGroup);
  for (const bidGroup of clearedBidGroup) {
    bidGroup.awardedDays = undefined;
    bidGroup.awardType = undefined;
    bidGroup.awardedTimeOffType = undefined;
    bidGroup.awardBsAmPm = undefined;
  }

  return {
    allotmentDayState: allotmentDayState.map(clearAwardedEmps),
    bidGroup: clearedBidGroup,
  };
};

export const assignBidLine = (bidLines, bidLineIdx, employee) => {
  let updatedBidLines = copyJsonObject(bidLines);
  updatedBidLines[bidLineIdx].awardedEid = employee.eid;
  updatedBidLines[bidLineIdx].awardType = employee.awardType;
  updatedBidLines[bidLineIdx].awardedShortName = employee.shortName;
  updatedBidLines[bidLineIdx].awardedLastName = employee.lastName;
  updatedBidLines[bidLineIdx].awardedRank = employee.rank;
  updatedBidLines[bidLineIdx].permanentBidPreferenceUsed = employee.permanentBidPreferenceUsed;
  return updatedBidLines;
};

export const assignDupedBidLine = (bidLines, lineBeingDupedIdx, dupedLineObj, employee) => {
  let dupedLine = copyJsonObject(dupedLineObj.dupedLine);
  dupedLine.awardType = employee.awardType;
  dupedLine.awardedRank = employee.rank;
  dupedLine.assignedEmployee = undefined;
  dupedLine.awardedEid = employee.eid;
  dupedLine.awardedShortName = employee.shortName;
  dupedLine.awardedLastName = employee.lastName;
  dupedLine.permanentBidPreferenceUsed = employee.permanentBidPreferenceUsed;

  let updatedBidLines = copyJsonObject(bidLines);
  updatedBidLines.splice(lineBeingDupedIdx + dupedLineObj.dupeCount, 0, dupedLine);
  return updatedBidLines;
};

export const unAssignBidLines = (bidLines, selectedBidLineIdx) => {
  let updatedBidLines = copyJsonObject(bidLines);
  updatedBidLines[selectedBidLineIdx].awardedEid = undefined;
  updatedBidLines[selectedBidLineIdx].awardType = undefined;
  updatedBidLines[selectedBidLineIdx].awardedShortName = undefined;
  updatedBidLines[selectedBidLineIdx].awardedLastName = undefined;
  updatedBidLines[selectedBidLineIdx].awardedRank = undefined;
  updatedBidLines[selectedBidLineIdx].permanentBidPreferenceUsed = undefined;
  return updatedBidLines;
};

export const assignBidGroup = (bidGroup, selectedBidGroupIdx, bidLineNumber, awardType, isNoBidOverridden = false) => {
  let updatedBidGroup = copyJsonObject(bidGroup);
  updatedBidGroup[selectedBidGroupIdx].awardType = awardType;
  updatedBidGroup[selectedBidGroupIdx].awardedLine = bidLineNumber;
  updatedBidGroup[selectedBidGroupIdx].isExpanded = false;
  updatedBidGroup[selectedBidGroupIdx].isNoBidOverridden = isNoBidOverridden;
  return updatedBidGroup;
};

export const unAssignBidGroup = (bidGroup, selectedBidGroupIdx) => {
  let updatedBidGroup = copyJsonObject(bidGroup);
  updatedBidGroup[selectedBidGroupIdx].awardedLine = undefined;
  return updatedBidGroup;
};

export const clearBidAssignment = (bidLines, bidGroup, employeeId) => {
  let copiedBidLines = copyJsonObject(bidLines);
  let copiedBidGroup = copyJsonObject(bidGroup);
  const selectedBidLineIdx = copiedBidLines.findIndex((bidLine) => bidLine?.awardedEid === employeeId);

  if (selectedBidLineIdx !== -1) {
    const isEmpAwardedADupeLine = copiedBidLines[selectedBidLineIdx].isDupedLine;
    if (isEmpAwardedADupeLine) {
      // Clear from bidLines
      copiedBidLines.splice(selectedBidLineIdx, 1);
      let cleanUpDupedLinesResult = cleanUpDupedLines(copiedBidLines, copiedBidGroup);
      copiedBidLines = cleanUpDupedLinesResult.bidLines;
      copiedBidGroup = cleanUpDupedLinesResult.bidGroup;
      // Clear from bidGroup
      const selectedBidGroupIdx = copiedBidGroup.findIndex((emp) => emp?.eid === employeeId);
      if (selectedBidGroupIdx !== -1) {
        copiedBidGroup = unAssignBidGroup(copiedBidGroup, selectedBidGroupIdx);
      }
      return { bidLines: copiedBidLines, bidGroup: copiedBidGroup };
    } else if (isEmpAwardedALineContainingDupeLines(copiedBidLines, copiedBidLines[selectedBidLineIdx].lineNumber)) {
      let cleanUpDupedLinesResult = adjustLineNumbers(
        copiedBidLines,
        copiedBidGroup,
        copiedBidLines[selectedBidLineIdx].lineNumber
      );
      copiedBidLines = cleanUpDupedLinesResult.bidLines;
      copiedBidGroup = cleanUpDupedLinesResult.bidGroup;
      return { bidLines: copiedBidLines, bidGroup: copiedBidGroup };
    } else {
      const updatedBidLines = unAssignBidLines(copiedBidLines, selectedBidLineIdx);
      // Clear from bidGroup
      const selectedBidGroupIdx = copiedBidGroup.findIndex((emp) => emp?.eid === employeeId);
      if (selectedBidGroupIdx !== -1) {
        copiedBidGroup = unAssignBidGroup(copiedBidGroup, selectedBidGroupIdx);
      }
      return { bidLines: updatedBidLines, bidGroup: copiedBidGroup };
    }
  }
  return { bidLines: copiedBidLines, bidGroup: copiedBidGroup };
};
